import React from 'react';
import '../styles/Membership.css'

const Marker = React.memo(function Marker(props) {
  const { lng, lat, image } = props;

  return (
    <div
      key={'store_map_'}
      className="StoreMarkerWrapper"
      lat={lat}
      lng={lng}
    >
      <div className="StoreMarker">
        <div className="StoreMarkerImage">
          <img src={process.env.PUBLIC_URL + image} draggable={false} />
        </div>
      </div>
      <div className="StoreMarkerLeg" />
    </div>
  );
});

export default Marker;
